import { STORAGE_PREFIX as prefix } from './redux';

export const onboardingFormSaving = (state) => state[prefix].saving;
